import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "./services/api";

export default function Contact() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await api.post('/contact', formData);

      setSubmitted(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="text-4xl font-bold mb-6">{t('contact.title')}</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        <div>
          <h2 className="text-2xl font-semibold mb-4">{t('contact.getInTouch')}</h2>
          <p className="text-raya-text-primary/90 font-medium mb-6">
            {t('contact.description')}
          </p>

          <div className="space-y-4">
            <div>
              <h3 className="font-semibold mb-2">{t('contact.email')}</h3>
              <p className="text-raya-text-primary/90 font-medium">
                info@raya-elegance.com
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">{t('contact.phone')}</h3>
              <p className="text-raya-text-primary/90 font-medium">+1 (843) 847-0158</p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">{t('contact.hours')}</h3>
              <p className="text-raya-text-primary/90 font-medium">
                {t('contact.hoursWeek')}
                <br />
                {t('contact.hoursWeekend')}
              </p>
            </div>
          </div>
        </div>

        <div>
          {submitted ? (
            <div className="bg-raya-accent-light border border-raya-accent/50 rounded-lg p-4 text-raya-accent">
              {t('contact.successMessage')}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold mb-2">{t('contact.form.name')}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-raya-border rounded-lg bg-raya-card focus:outline-none focus:ring-2 focus:ring-yellow-500/50"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  {t('contact.form.email')}
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-raya-border rounded-lg bg-raya-card focus:outline-none focus:ring-2 focus:ring-yellow-500/50"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  {t('contact.form.subject')}
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 border border-raya-border rounded-lg bg-raya-card focus:outline-none focus:ring-2 focus:ring-yellow-500/50"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2">
                  {t('contact.form.message')}
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-2 border border-raya-border rounded-lg bg-raya-card focus:outline-none focus:ring-2 focus:ring-raya-accent/50"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className={`w-full font-semibold py-3 rounded-lg transition shadow-lg ${
                  loading 
                    ? "bg-zinc-400 cursor-not-allowed text-white" 
                    : "bg-raya-accent hover:bg-yellow-700 text-black"
                }`}
              >
                {loading ? t('contact.form.sending', { defaultValue: 'Sending...' }) : t('contact.form.send')}
              </button>
              {error && (
                <p className="text-red-500 text-sm mt-2 text-center">{error}</p>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
